<template>
  <resource-edit-wrapper
    :title="$t('resources.authors.edit_author')"
    :need-modal="showModal"
    @saveAction="$refs['authorForm'].submit()">
    <AuthorForm :author="item" @isDirtyForm="isDirtyForm" ref="authorForm"></AuthorForm>
  </resource-edit-wrapper>
</template>

<script>
  import ResourceEditWrapper from "@/components/resourceWrappers/ResourceEditWrapper";
  import AuthorForm from "@/components/forms/AuthorForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceEditWrapper,
      AuthorForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
  };
</script>
